import GuidanceRegistry from '../guidance-registry.js';
import {guidanceUtils} from "../guidance-utils.js";
import moment from 'moment';
import { romeApi } from '../../framework/utils/rome-api.js';
import { modalService } from "../../framework/utils/modal-service";
import EnrollmentConfirmation from "../../action-items/types/EnrollmentConfirmation";

GuidanceRegistry.register({
    type: "action-item-ewf-complete-portal-enrollments",
    prompt: (guidanceItem) => getPrompt(guidanceItem.planYearStartDate, guidanceItem.workflowType),
    briefDescription: 'Portal Enrollments',
    beforeLoad: async (component) => {
        await component.refreshPermissions();
    },
    openAction: {
        text: "Where to enter participant enrollment information?",
        url: (guidanceItem) => getOpenUrl(guidanceItem),
        row: null
    },
    helpUrl: async(guidanceItem) => {
        if(guidanceItem.workflowType == 'new-employer-workflow') return;

        let helpArticle = await getHelpLink(`${guidanceItem.type}-renewal`);
        return helpArticle.url;
    },
    actions: [
        {
            text: "Finish Enrollments",
            recommended: true,
            loadNextGuidance: false,
            click: async (component, guidanceItem) => {
                
                let result = await validateEnrollments(guidanceItem.actionItemId);

                var enrollmentsComplete = await modalService.show("EnrollmentConfirmation", EnrollmentConfirmation, { 
                    lines: result.warnings,
                    errorStyle: true,
                });

                if(enrollmentsComplete == true) {
                    await romeApi.post(`actionitem/v-2/${guidanceItem.actionItemId}/complete`);
                    await component.refresh();
                }
            },
        },
    ]
});

function getOpenUrl(guidanceItem) {
    return guidanceItem.workflowType == "new-employer-workflow" ? `/employer/${guidanceItem.employerId}/participants` : `/employer/${guidanceItem.employerId}/accounts`;
}

function getPrompt(planYearStartDate, workflowType) {
    let dateString = guidanceUtils.getEnrollmentDueDate(planYearStartDate);

    let prompt = workflowType == "new-employer-workflow" 
        ? "Select the Participants tab on the left, click Add Participant, and fill in the requested information. Repeat for each participant. " 
        : 'Use the "Accounts" tab on the left to add new elections for those currently enrolled. To add new participants, use the "Participants" tab to the left.  For step by step instructions, click the ? icon in the right-hand side of this panel. ';
    
        return prompt.concat(`<strong>Please  submit your enrollments by ${dateString}.</strong>`);
}

async function validateEnrollments(actionItemId) {
    return await romeApi.post(`actionitem/v-2/${actionItemId}/validate`);
}

async function getHelpLink(helpCode){
    return await romeApi.get(`help/${helpCode}`);
}


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-complete-portal-enrollments.js